import { frontendURL } from '../../../helper/URLHelper';

const EmailSequenceList = () => import('./EmailSequenceList.vue');
const EmailSequenceFlowEditor = () => import('./EmailSequenceFlowEditor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/email-sequences'),
      name: 'email_sequences',
      component: EmailSequenceList,
      meta: {
        permissions: ['administrator', 'email_sequences_view'],
        featureFlag: 'email_sequences',
      },
    },
    {
      path: frontendURL('accounts/:accountId/email-sequences/:sequenceId/edit'),
      name: 'email_sequence_editor',
      component: EmailSequenceFlowEditor,
      meta: {
        permissions: ['administrator', 'email_sequences_view'],
        featureFlag: 'email_sequences',
      },
    },
  ],
};
